var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFooter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#8bc53f;}.cls-3{fill:#618921;}.cls-4{fill:#fed385;}.cls-5{fill:#86b739;}.cls-6{fill:url(#linear-gradient);}.cls-7{fill:url(#linear-gradient-2);}.cls-8{fill:#fff;}.cls-9{fill:#f0806d;}.cls-10{fill:url(#linear-gradient-3);}.cls-11{fill:url(#linear-gradient-4);}.cls-12{fill:url(#linear-gradient-5);}.cls-13{fill:url(#linear-gradient-6);}.cls-14{fill:url(#linear-gradient-7);}.cls-15{fill:#9cc94f;}.cls-16{fill:#0e1d28;}.cls-17{fill:#e6e6e6;}.cls-18{fill:#bc584b;}.cls-19{fill:#0a6672;}.cls-20{fill:#023f47;}.cls-21{fill:#aa423a;}.cls-22{fill:#f1b287;}.cls-23{fill:#ffb085;}.cls-24{fill:#feffff;}.cls-25{fill:#d49166;}.cls-26{fill:#e8a476;}.cls-27{fill:#ccc;}.cls-28{fill:#182c3c;}.cls-29{fill:#688920;}.cls-30{fill:#5d751a;}.cls-31{fill:#c63e3e;}.cls-32{fill:#dbd8bd;}.cls-33{fill:#351807;}.cls-34{fill:#542913;}.cls-35{fill:#110804;}.cls-36,.cls-37{fill:#ff5c55;}.cls-37{opacity:0.5;mix-blend-mode:multiply;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 81.09,
    y1: 56.55,
    x2: 129.54,
    y2: 56.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d5e4ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#edfffe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 168.72,
    y1: 60.26,
    x2: 217.18,
    y2: 60.26,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 88.07,
    y1: 145.33,
    x2: 106.5,
    y2: 145.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd486"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8ac141"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 88.07,
    y1: 139.66,
    x2: 106.5,
    y2: 139.66,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 88.07,
    y1: 133.99,
    x2: 106.5,
    y2: 133.99,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 33.14,
    y1: 183.43,
    x2: 107.11,
    y2: 183.43,
    gradientTransform: "translate(173.57 16.51) rotate(52.71)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 159.04,
    y1: 221.26,
    x2: 214.15,
    y2: 221.26,
    gradientTransform: "translate(108.41 -57.42) rotate(24.47)",
    xlinkHref: "#linear-gradient-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M98.6,262.44c-2.33-2.3-3.23-8.32,4.44-8.61,0,0-3,5-2,5.49s2.92-5.8,2.92-5.8,5.86-.57,7.75.34c0,0-5,4.1-4,4.34s6.47-3.78,6.47-3.78,5.46.93,5.17,4.26-2.17,4.36-3,4.27-5.66-1.93-5.77-1.26,2.81,2.89,4.85,3c-4.69,4.65-6.12,4.08-10.78-.88-1.59-.73-3-.72-2.3,0s3.55,1.46,4.46,3.08c3.79,5.53-8.77.14-8-2.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M116.7,258.77s-14.83-.57-18.1,3.67a10.78,10.78,0,0,1-2.95,4.14l-.35.95s2.57-2.71,3.49-2.87C98.79,264.66,97.35,259.4,116.7,258.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M95.65,266.58a9.32,9.32,0,0,0-3.41,6.56l.58.05s1-4.35,2.85-6.05S95.65,266.58,95.65,266.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M85.45,256.92c3.53-1.61,7-8-1.43-11.4,0,0,1.27,6.78,0,6.94s-.88-7.66-.88-7.66-6.3-3-8.77-2.79c0,0,3.9,6.62,2.63,6.46s-5.66-6.86-5.66-6.86-6.46-1.2-7.5,2.63.64,5.74,1.59,6,7.1.16,6.94,1-4.3,2.07-6.62,1.36c3.43,7.17,5.06,7,12.36,3.42,2.08-.15,3.59.4,2.56,1s-4.55.19-6.22,1.61c-6.63,4.61,9.74,3.72,9.88.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M66.79,245.44s16.75,5.42,18.66,11.48a12.69,12.69,0,0,0,1.6,5.82v1.2s-1.76-4.07-2.72-4.62C84.33,259.32,88.08,254.05,66.79,245.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M87.05,262.74a11.08,11.08,0,0,1,1.11,8.7l-.67-.18s.65-5.26-.7-7.9S87.05,262.74,87.05,262.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M95,252.3c-4.7-2.28-9.29-10.3,1.89-15,0,0-1.68,8.94,0,9.15S98,236.32,98,236.32s8.3-4,11.56-3.68c0,0-5.15,8.73-3.47,8.52s7.46-9,7.46-9,8.52-1.58,9.89,3.47-.84,7.57-2.11,7.88-9.35.21-9.14,1.26,5.67,2.74,8.72,1.79c-4.88,9.75-6.38,9.19-16.29,4.52-2.73-.21-4.73.53-3.37,1.26s6,.24,8.2,2.12c8.85,6.07-12.86,4.9-13,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M119.57,237.16S97.49,244.31,95,252.3A16.82,16.82,0,0,1,92.86,260v1.57s2.32-5.36,3.58-6.09C96.44,255.46,91.5,248.52,119.57,237.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M92.86,260a14.57,14.57,0,0,0-1.46,11.46l.88-.23s-.85-6.94.93-10.42S92.86,260,92.86,260Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M94.7,285.09a15.45,15.45,0,0,0,15.45-15.45H79.26A15.45,15.45,0,0,0,94.7,285.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M98.5,285a15.47,15.47,0,0,1-17.36-15.33H85A15.45,15.45,0,0,0,98.5,285Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M108.45,284H81a1.91,1.91,0,0,0-1.91,1.9h31.32A1.9,1.9,0,0,0,108.45,284Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 78.75,
    y: 269.64,
    width: 31.75,
    height: 0.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 81.09,
    y: 51.55,
    width: 48.45,
    height: 10,
    rx: 3.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 168.72,
    y: 55.26,
    width: 48.45,
    height: 10,
    rx: 3.78
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M300,162.34l-25.23,11.47-25.21,11.46-33,15-70,31.81L69,173.05,42.66,153,21.5,136.86,0,120.49a153.49,153.49,0,0,1,300,41.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M275,166.08q0,3.9-.23,7.73l-25.21,11.46-33,15-70,31.81L69,173.05,42.66,153,21.5,136.86A128.43,128.43,0,0,1,275,166.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M251.31,166.08a105.45,105.45,0,0,1-1.75,19.19l-33,15-70,31.81L69,173.05,42.66,153a104.74,104.74,0,0,1,208.65,13.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M224.44,166.08a77.52,77.52,0,0,1-7.9,34.21l-70,31.81L69,173.05q-.32-3.45-.31-7a77.86,77.86,0,1,1,155.72,0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 146.58,
    cy: 166.08,
    r: 35.96,
    transform: "translate(-10.04 9.43) rotate(-3.56)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 24.35,
    y: 227.97,
    width: 36.62,
    height: 7.56,
    rx: 3.78
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M58.8,204a16.15,16.15,0,0,1-9.47,14.7A16.14,16.14,0,0,1,26.52,204a16.14,16.14,0,0,1,32.28,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M46.37,199.75a3.68,3.68,0,1,1-3.68-3.68A3.68,3.68,0,0,1,46.37,199.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M49.33,211.74v7a16.17,16.17,0,0,1-13.34,0v-7a6.67,6.67,0,0,1,13.34,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 141.39,
    y: 243.8,
    width: 17.21,
    height: 4.59,
    rx: 2.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 141.39,
    y: 252.39,
    width: 17.21,
    height: 4.59,
    rx: 2.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 141.39,
    y: 260.99,
    width: 17.21,
    height: 4.59,
    rx: 2.3
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "23.27 92.93 49.06 92.93 49.06 111.63 49.06 115.57 45.12 111.63 23.27 111.63 23.27 92.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M114.4,55.1a17.58,17.58,0,0,0-15,31.78c.36.17.72.32,1.08.47a17.58,17.58,0,0,0,14-32.25Zm4.39,21.52a13.18,13.18,0,0,1-13,7.51,12.85,12.85,0,0,1-3.76-.88c-.28-.11-.55-.22-.82-.35a13.18,13.18,0,1,1,17.55-6.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M95.21,77.11l-3.9,2a17.61,17.61,0,0,1,2.77-20.22l3.21,3a13.18,13.18,0,0,0-2.08,15.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M102.06,83.25l-1.62,4.1c-.36-.15-.72-.3-1.08-.47a17.5,17.5,0,0,1-8-7.73l3.9-2a13.08,13.08,0,0,0,6,5.79C101.51,83,101.78,83.14,102.06,83.25Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 88.07,
    y: 143.7,
    width: 18.44,
    height: 3.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 88.07,
    y: 138.03,
    width: 18.44,
    height: 3.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 88.07,
    y: 132.36,
    width: 18.44,
    height: 3.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 78.8,
    y: 102.22,
    width: 9.01,
    height: 2.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 78.8,
    y: 107.08,
    width: 9.01,
    height: 2.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 78.8,
    y: 97.37,
    width: 9.01,
    height: 2.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 69.75,
    y: 137.22,
    width: 0.75,
    height: 92.41,
    transform: "translate(-118.29 128.09) rotate(-52.71)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 156.5,
    y: 220.89,
    width: 60.2,
    height: 0.75,
    transform: "translate(-74.89 97.16) rotate(-24.47)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 146.58,
    cy: 166.08,
    r: 24.79
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M223.62,108s.53-7-.61-8.13-2.72-5.09-11-5.62a2.32,2.32,0,0,0-2.47,1.29c-.69,1.6-3.63,3.5-3.63,3.5s-3.51,3.34-.93,9.68l3,3.68,2.05,8.54,10.17-3.68s1.76-.85,1.82-3.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.51,279.13s-3.65,7.13-8.66,8c-5.66-.3-5,2.66-5,2.66s13.32,6.72,24.71-.91v1.71l6-.34v-4.44h-1l.31-2A19.89,19.89,0,0,0,214.51,279.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210,274.27s-3.38,4.63-7.59,5.54c-5.93-.51-6.09.23-5.92,1.14s2.62,4.72,15.72,1.73l4.78-5.55S214.35,278.18,210,274.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M222.64,124.13l9.22,3.64s6.6,2.84,3.07,13.66c0,0,1.94,2.85,1.6,9.91,0,0,2.5,2.28.57,11.85,0,0,.34,2.16-5.47,2.05a18.3,18.3,0,0,1-3.42.56s-.34,3.88-.34,5.24c0,0,1.14,2.51,1.59,11.05l2.85,11.73-3.07.8s-20.05-1-27.22.8l-1.14-1.14-1.71.11s.91-22.55.68-25.74S197,147,202.13,134.14c0,0,4.9-2.39,4.9-7.06,0,0-.34-.78,1.59-3l12.64-3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M199.05,158.17s-5.58,1-7.51,0H178.78s2.62.12,2.51,2.05l-.8,8.2s8.77.12,9.45-.68c0,0,6.72,1.25,9.91.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M178,163.44s.79,4.19,2.5,5c0,0,4.67-10.7-1.71-10.25C178.78,158.17,177.42,159.71,178,163.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M199.4,165.69c-.91.11-18.6-.46-18.6-.46l-.31,3.19s8.53.19,9.45-.68c0,0,6.44,1.23,9.91.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M229.24,194.62s-1.29.68-.53,7a148,148,0,0,1,2.2,22.4s6.92,10,0,59.83c0,0-9.06-5-12.5-3.34l-3.9-1.36s3.19-7.29,2.27-10,1.12-10.47,1.63-10.47.35-12.3-1.78-11.39a29.22,29.22,0,0,1-2.12-7.14s-4-30.62-9.43-45.22A75.24,75.24,0,0,1,229.24,194.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M210,274.27s2.58-6.23,3.8-5.77c0,0-2.58-1.52,0-8.36,0,0,1.67-2.27,0-3.49,0,0-9-42.82-10.94-46l-1.93-16.36,4.2-.51,11.25,43.29,3.2,32.5-4.21,7.52S212.38,277.76,210,274.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M221.26,120.93s-14.57,8.21-20,33.11h1.06s9.72-19.78,14.5-24.41c0,0,.38-1.32-1.29-1.75a8.7,8.7,0,0,0,3.57-1,8.92,8.92,0,0,0,3.5-2.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M229.24,194.62a21.54,21.54,0,0,0-3.88-.5s-1.19,1.75.29,5.62,1.71,20.79,1.71,20.79-.06,4.61,1.48,7,3.59,18.8-1.1,54a12.32,12.32,0,0,1,3.17,2.29s3.34-24.75,3.06-39.5c0,0,.09-13.27-3.06-20.33,0,0-.63-15.3-2.2-22.4C228.71,201.6,227.7,196.73,229.24,194.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M228.31,126.37s-8,3.35-5.67,17.32c0,0,.88,5.87,2.1,7.64,0,0,2,2.34-.66,2.71a6.39,6.39,0,0,0-2.6.74L211,154s1.59,8.66-4.75,11.64l22.89,0,2.54-.48s5.49.47,5.56-2.56c0,0,1.84-8.09-.66-11.34,0,0,.68-5.86-1.6-9.91,0,0,3.55-9-2.55-13.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M211,154s-5.4-.54-5.17,7.84a16.34,16.34,0,0,0,.42,3.8S212.28,163.65,211,154Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M237.44,161.19s-1.09,2.28-12.59,2.79c-11.56-.69-15.49-1.08-15.49-1.08s-.35,1.4-3.16,2.78l22,.12s2.51-.3,3.42-.56C231.63,165.24,237.89,166,237.44,161.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M228.21,165.8l-2.28,7.52.35,5.51s.68,2.27,1.93,5.54,1,10.25,1,10.25l3.07-.8-2.85-11.73s-.38-8.58-1.59-11.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M207.8,194.62s-.42,5,3,11.44c2.15,8.72,4.42,19.93,4.42,19.93l1.08,11.07-8.32-32-2.93-10.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M217.08,244.64s2.54,2.54,2.45,4.93l.48,8.32a10.46,10.46,0,0,1-1.06,5.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M203.73,135.55a12.9,12.9,0,0,0-3,5s-1.12,9.41.57,13.44C201.3,154,204,142.07,203.73,135.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M208.72,127.61H207a6.58,6.58,0,0,1-2.74,5s-2.91,11.31-2.44,19.1c0,0,2.12-8,4.23-12.07a20.34,20.34,0,0,1,4-10.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M208,113.07l.47,9.49s.91.57.45,3.7l11.3-4.76v-4.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M181.29,160.22s-3.63-4.46-7-3.87c0,0-1.65-1-2.14-.06,0,0-.1-1.14-1.55-.39,0,0-3.3-2-2.92.35a6.6,6.6,0,0,0,1.85,1,2.09,2.09,0,0,0-1.37,2.09s-1.08.12-1.42-.28-1.25-1.65-2.28-1.71c-1.08.35.57,1.88.57,1.88a7.44,7.44,0,0,0,2.62,2l2,.23s1.41,1.37,1.48,1.87c0,0,9.17-.4,9.75,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M236.63,160.38s-2-8.47-10.24-6.35C226.39,154,232.8,153.31,236.63,160.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M235.8,133.74s-.79,4.79-1.37,5.36-4.87-6-5.31-6.6c0,0,5.83,11.91,7.44,16.44,0,0-.09-5.4-1.63-7.51C234.93,141.43,236.39,135.85,235.8,133.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M199.85,168.65s2.36,23.71,2.8,25.12l-3.48.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M221.48,154.78s-9.48,1.2-10.34,1.84L211,154Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M222.59,143.08s0,10.69-1,11.72a6.45,6.45,0,0,1,2.37-.72s2.85,0,.84-2.68A30.57,30.57,0,0,1,222.59,143.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M221.26,120.93s-.3-1.1-2-.72-9,4.78-11.16,6.76c0,0,2,1.9,2,2.28s-3,2.67-4.16,10.83A43.63,43.63,0,0,1,221.26,120.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M219.06,115.48v4.76s-5.54,2.37-8.81-1.32a16.85,16.85,0,0,1-2.27-5.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M181.08,162.39s-6.58-1.08-10.89-.42c0,0,1,1,.95,1.32,0,0,7.31-.38,9.76,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M180.49,168.42s-1.52-.35-2.5-5c0,0,2.71-.15,2.89.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M211,154s-.82,7.72-4.43,7.56c0,0,.58,1.26,3.37.61C209.89,162.21,211.8,159.32,211,154Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M215.57,99.48s-3.87-2.73-6.76.46c-2.12,1.84-.83,5.24-.83,5.24s-1.23.22-.39,1.89v1.49l0,2.12s-.22,1.09-1.21-.16c.11-1.22-.47-2.5-1.49-1.81s.53,4.74,2,4.36H208s1.36,4.86,4.48,5.7,7.51-1.22,8.27-5.17c.91-.15,3.34.08,2.89-5.61-2.36-.92-1.6,1.59-1.6,1.59s.38,1.82-.76,2v-3.34s.23-1.05-.31-1.4c0-.17.46-2.81-.37-3.53s-1.17-4.1-2.73-4A2.61,2.61,0,0,1,215.57,99.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M214.66,280.28l3.18,1.1s9.33.54,11.13,3.32c0,1.83-4.85,1.71-4.85,1.71s-9.42,7.43-22.93,2.41a5.48,5.48,0,0,1,4.78-1.35S208.79,288.25,214.66,280.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M209.37,274.91a11.63,11.63,0,0,0,5.1,3.33l-.58,1.48a7.16,7.16,0,0,0-5.35,1.85s-9.12,1.39-11.95-.67c-.78-1.86,5.78-1.11,5.78-1.11A13.55,13.55,0,0,0,209.37,274.91Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "276.68 135.39 281.7 117.29 244.17 125.52 237.34 144.01 276.68 135.39"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-29",
    cx: 146.58,
    cy: 166.08,
    r: 11.38
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M148.64,168.8,277.8,140.48l-1.12-5.09L147.47,163.72h0a2.61,2.61,0,0,0,1.11,5.09h.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "252.32 162.97 240.25 148.72 277.8 140.49 291.69 154.47 252.32 162.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M208.47,154.68s-1.28.75-1.35,1.65c0,0-5.11-.71-6.31-1.65,0,0-5-.83-3.59,3,0,0,6.59,3.48,6.71,4.08H208s2.4-1.2,3.14-5.51c0,0-2.72-3.54-2.6-4.37-.36-.34-1.55-.08-1.26,1.73A2.29,2.29,0,0,0,208.47,154.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M197.22,157.68l7.19,3,3.71.19a4.75,4.75,0,0,0-.12.92h-4.07A75.81,75.81,0,0,0,197.22,157.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M222.85,109.28a13.27,13.27,0,0,0-.22,1.77c.06.23,0,1-.67,1.06l.12-.47.44-2A5.08,5.08,0,0,1,222.85,109.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M205.58,109.65a13.59,13.59,0,0,1,.43,1.73c0,.24.09,1,.79,1l-.17-.46S206,110,206,110,205.58,109.65,205.58,109.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M212.93,108a2.58,2.58,0,0,0-.61-.44,1.72,1.72,0,0,0-1-.14,1.26,1.26,0,0,0-.83.34,1,1,0,0,1-.35.28,3.3,3.3,0,0,0,.69.32,4.81,4.81,0,0,0,2.13-.31h-.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M210.48,108a1.31,1.31,0,0,1,.83-.34,1.74,1.74,0,0,1,1,.15,3,3,0,0,1,.45.27l.21-.05h-.05l.1,0a2.93,2.93,0,0,0-.7-.46,1.71,1.71,0,0,0-1-.14,1.31,1.31,0,0,0-.83.34,1.13,1.13,0,0,1-.34.28l.21.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M211.05,107.92a.59.59,0,1,1,.59.58A.59.59,0,0,1,211.05,107.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M211.26,108.06a.35.35,0,0,1,.38-.31.35.35,0,0,1,.37.31.33.33,0,0,1-.37.3A.34.34,0,0,1,211.26,108.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.4,107.92a.23.23,0,0,1,.24-.23.23.23,0,1,1,0,.46A.23.23,0,0,1,211.4,107.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M211.38,107.87a.11.11,0,0,1,.12-.11.11.11,0,0,1,.11.11.11.11,0,0,1-.11.12A.12.12,0,0,1,211.38,107.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M212.93,108a4.5,4.5,0,0,0-.9-.54,2.36,2.36,0,0,0-1.43.25l-.33.29-.3,0a1.06,1.06,0,0,1,.45-.49,4.23,4.23,0,0,1,1.65-.24,11.86,11.86,0,0,1,1,.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M210.27,108c.17.1.13.12.32.18a2,2,0,0,0,1,.14,6.65,6.65,0,0,0,1.08-.21c.1,0,.29-.15.37-.11s-.1.08-.15.1a6,6,0,0,1-1.43.41,2.06,2.06,0,0,1-.78-.09A1.52,1.52,0,0,1,210,108"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M212.92,106l-.47-.09a.15.15,0,0,1,0,.13,1.51,1.51,0,0,0-.72-.15l.06.1a4.17,4.17,0,0,0-1.4-.25l.09.06a1.71,1.71,0,0,0-1.5.94,3.92,3.92,0,0,0,.78-.25c.59-.16,1.18.21,1.77.36a5.25,5.25,0,0,0,1.63.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M215.89,108.07a2.3,2.3,0,0,1,.61-.43,1.75,1.75,0,0,1,1-.15,1.32,1.32,0,0,1,.83.34,1.17,1.17,0,0,0,.34.29,3.47,3.47,0,0,1-.68.31,4.79,4.79,0,0,1-2.13-.31h.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M218.33,108.09a1.27,1.27,0,0,0-.82-.35,1.74,1.74,0,0,0-1,.15,3,3,0,0,0-.45.27l-.21,0h0l-.1,0a2.74,2.74,0,0,1,.7-.46,1.71,1.71,0,0,1,1-.14,1.31,1.31,0,0,1,.83.34,1.13,1.13,0,0,0,.34.28l-.21.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M218,108a.58.58,0,0,0-.58-.58.59.59,0,0,0-.59.58.59.59,0,0,0,1.17,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M217.81,108.11a.35.35,0,0,0-.37-.31.35.35,0,0,0-.38.31.34.34,0,0,0,.38.3A.34.34,0,0,0,217.81,108.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.67,108a.23.23,0,0,0-.23-.23.23.23,0,1,0,.23.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M217.35,107.86a.12.12,0,0,0-.12-.12.12.12,0,0,0-.12.12.11.11,0,0,0,.12.11A.12.12,0,0,0,217.35,107.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M215.89,108.07a4.5,4.5,0,0,1,.9-.54,2.32,2.32,0,0,1,1.42.25l.34.29.29,0c0-.09-.11-.26-.44-.49a4.23,4.23,0,0,0-1.65-.24s-.73.53-1,.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M218.55,108.07c-.17.1-.13.12-.32.18a2,2,0,0,1-1,.14,7.9,7.9,0,0,1-1.08-.2c-.1,0-.29-.15-.37-.11s.1.07.15.09a6,6,0,0,0,1.42.41,1.91,1.91,0,0,0,.79-.09,1.44,1.44,0,0,0,.7-.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M216,106l.45-.09a.15.15,0,0,0,0,.13,1.36,1.36,0,0,1,.69-.14.18.18,0,0,0-.06.09,4,4,0,0,1,1.33-.23l-.08,0a1.63,1.63,0,0,1,1.43.89,3.59,3.59,0,0,1-.75-.23c-.56-.16-1.12.19-1.69.34a5,5,0,0,1-1.55.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M213.36,111.65c0,.16.64.37,1.32.41s1.26-.16,1.27-.32-.12-.17-.45-.19-.54.32-.85.31-.66-.45-.88-.42S213.36,111.57,213.36,111.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M216.82,113.94c0-.06.17-.16,0-.18-.37-.05-.85-.27-1.25-.36a1.2,1.2,0,0,0-.62-.05.82.82,0,0,1-.34.12c-.13,0-.23-.11-.37-.14-.59-.09-1.35.45-1.9.27,0,.05-.07.11,0,.15a5.75,5.75,0,0,0,.66.53,3.67,3.67,0,0,0,.79.4c.29,0,1.27,0,1.56,0a1.48,1.48,0,0,0,.77-.38,4.42,4.42,0,0,1,.73-.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M217.11,113.7c-.2-.1-.52,0-.74.06s-.66-.12-1-.06-.54.28-.83.26-.36-.14-.55-.18a2.87,2.87,0,0,0-.77,0,1.18,1.18,0,0,1-.61-.15.67.67,0,0,0-.23-.1.16.16,0,0,0-.18.12c0,.11.13.16.23.18a7.9,7.9,0,0,1,1.83.12,1.47,1.47,0,0,0,.35.08,1.34,1.34,0,0,0,.38-.14,4.25,4.25,0,0,1,1.81,0C216.9,113.94,217.17,113.85,217.11,113.7Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooter);
export default __webpack_public_path__ + "static/media/footer.dba177e222e0ce71ce38811f45f8eb51.svg";
export { ForwardRef as ReactComponent };